import { useUpdateSurfacePreferences } from "@/components/preferences/usePreferences.tsx";
import { Toggle } from "@/components/ui/toggle.tsx";
import { errorToast } from "@/components/ui/toast.tsx";
import { useState } from "react";
import { useKeyboardShortcutsEnabled } from "./useKeyboardShortcuts.ts";

export const KeyboardShortcutsToggle = () => {
  const keyboardShortcutsEnabled = useKeyboardShortcutsEnabled();
  const updateKeyboardPreferences = useUpdateSurfacePreferences("keyboard");
  const [isUpdating, setIsUpdating] = useState(false);

  const handleToggle = async (checked: boolean) => {
    setIsUpdating(true);
    try {
      await updateKeyboardPreferences({ shortcutsEnabled: checked ? "enabled" : "disabled" });
    } catch {
      errorToast("Failed to update keyboard shortcut preferences. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Toggle
      size="md"
      checked={keyboardShortcutsEnabled}
      onCheckedChange={handleToggle}
      disabled={isUpdating}
    />
  );
};
